<template>
  <v-container>
    <v-row v-for="m in metadataView" :key="m.name">
      <v-col>{{m.name}}</v-col>
      <v-col>{{m.value}}</v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  props: {
    callsheet: Object,
  },
  components: {},
  methods: {},
  data: () => ({}),

  computed: {
    // are there any callsheet analyses available
    metadata() {
      return this.callsheet && this.callsheet.callsheetMetadata;
    },
    metadataView() {
      console.log(this.callsheet);
      if (!this.metadata) return null;
      return Object.keys(this.metadata)
        .reduce((p, c) => {
          p.push({
            name: c,
            value: this.metadata[c],
          });
          return p;
        }, [])
        .filter((f) => f.value && f.name !== "__typename");
    },
  },
};
</script>
